export default __webpack_public_path__ + "static/media/cover_large_07.89bcd55a.jpg";